import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const res = await api.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        // Session persistence relies solely on the httpOnly `session_token`
        // cookie the backend sets on this response — never store it in
        // localStorage/sessionStorage (readable by any injected JS, i.e. XSS).
        // Strip the hash so we don't reprocess on refresh
        window.history.replaceState({}, document.title, "/admin");
        if (!res.data?.is_admin) {
          toast.error("This Google account is not authorised for admin access.");
          navigate("/admin", { replace: true });
          return;
        }
        toast.success(`Welcome back, ${res.data.user?.name || "Admin"}`);
        navigate("/admin", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        navigate("/admin", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center">
        <div className="text-[#d4af37] font-display text-3xl tracking-widest-2 uppercase animate-pulse">
          Signing you in
        </div>
        <div className="mt-4 text-white/60 text-sm">Setting up your admin session…</div>
      </div>
    </div>
  );
}
